import http from '@/utils/http';

/**
 * @description 支付结果
 */
export function payCallback(data) {
  return http('post', '/EMP/ChangePaymentCallBack', { data });
}